/**
 * Normaliza un valor para que sea compatible con los valores de las opciones
 * Sustituye tildes por sus equivalentes sin tilde, espacios por guiones, y elimina caracteres no alfanuméricos.
 * @param value El valor a normalizar
 * @returns El valor normalizado
 */
export function normalizeValue(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')              // Separa las tildes del carácter base
    .replace(/[\u0300-\u036f]/g, '') // Elimina los signos diacríticos (tildes)
    .replace(/\s+/g, '-')          // Reemplaza espacios por guiones
    .replace(/[^\w-]/g, '');       // Elimina caracteres no alfanuméricos excepto guiones
}